<div class="mb-3 zf-s3-upload-document">
  <!--  <input class="form-control" type="file" id="formFile" (change)="selectFileMultiples($event)">-->

  <!--  <div *ngIf="files.length" class="files-list">-->
  <!--    <div class="single-file" *ngFor="let item of files; let i = index">-->
  <!--      <zf-item-upload [type]="'document'"-->
  <!--                      [data]="item"-->
  <!--                      (onUploaded)="onMultipleUploaded($event)"-->
  <!--                      (onRemoved)="onRemovedFile($event)"></zf-item-upload>-->
  <!--    </div>-->
  <!--  </div>-->

  <div class="image-container-grid" [ngClass]="{ 'multiple-grid': multiple }">
    <div class="column-1">
      <div class="container_multiple">
        <input
          type="file"
          [multiple]="multiple"
          (change)="selectFileMultiples($event)"
        />
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="63"
          height="64"
          viewBox="0 0 63 64"
        >
          <g fill="#3B454F" fill-rule="nonzero">
            <path
              d="M42.656 15.135a1.953 1.953 0 0 1-1.391-.578L31.5 4.795l-9.765 9.762a1.97 1.97 0 1 1-2.785-2.785L30.106.616a1.97 1.97 0 0 1 2.785 0l11.157 11.156a1.97 1.97 0 0 1-1.392 3.363z"
            />
            <path
              d="M31.5 36.791a1.97 1.97 0 0 1-1.969-1.969V2.01a1.97 1.97 0 0 1 3.938 0v32.812a1.97 1.97 0 0 1-1.969 1.969z"
            />
            <path
              d="M55.781 63.041H7.22A7.225 7.225 0 0 1 0 55.822V41.385a4.599 4.599 0 0 1 4.594-4.594h7.234a4.567 4.567 0 0 1 4.402 3.276l2.814 9.382a.658.658 0 0 0 .628.467h23.656a.658.658 0 0 0 .628-.467l2.814-9.385a4.572 4.572 0 0 1 4.402-3.273h7.234A4.599 4.599 0 0 1 63 41.385v14.437a7.225 7.225 0 0 1-7.219 7.219zM4.594 40.729a.656.656 0 0 0-.657.656v14.437a3.286 3.286 0 0 0 3.282 3.282H55.78a3.286 3.286 0 0 0 3.282-3.282V41.385a.656.656 0 0 0-.657-.656h-7.234a.65.65 0 0 0-.628.467L47.73 50.58a4.628 4.628 0 0 1-4.402 3.274H19.672a4.567 4.567 0 0 1-4.402-3.276l-2.814-9.382a.65.65 0 0 0-.628-.467H4.594z"
            />
          </g>
        </svg>

        <small *ngIf="!multiple">Drag and drop file here or Browse</small>
        <small *ngIf="multiple">Drag and drop files here or Browse</small>
      </div>
      <ng-container *ngIf="multiple">
        <span class="form-text help-multiple-text"
          ><span>Allowed extensions</span>:
          <span>{{ allowedExtensions }}</span></span
        >
      </ng-container>
    </div>

    <!-- Do not allow multiple
      ============================================================= -->

    <div *ngIf="!multiple" class="column-2">
      <div *ngIf="!files.length" class="files-list image-selected">
        <img [src]="defaultImages[extension]" />
      </div>

      <div *ngIf="files.length" class="files-list">
        <div class="single-file" *ngFor="let item of files; let i = index">
          <zf-item-upload
            [data]="item"
            (onUploaded)="onMultipleUploaded($event)"
            (onRemoved)="onRemovedFile($event)"
          ></zf-item-upload>
        </div>
      </div>
    </div>

    <!-- Allow multiple
      ============================================================= -->

    <div *ngIf="multiple" class="column-2">
      <div *ngIf="files.length" class="files-list">
        <div class="single-file" *ngFor="let item of files; let i = index">
          <zf-item-upload
            [data]="item"
            (onUploaded)="onMultipleUploaded($event)"
            (onRemoved)="onRemovedFile($event)"
          ></zf-item-upload>
        </div>
      </div>
    </div>
  </div>
</div>
<!--<div class="mb-3">-->
<!--<button class="btn btn-primary" [disabled]="!selectedFiles" (click)="upload()">Upload</button>-->
<!--  <button class="btn btn-primary" *ngIf="isUploaded" disabled><i class="fa fa-circle-o-notch fa-spin"></i></button>-->
<!--</div>-->
